const LoadingSpinner = () => (
    <div className="fixed inset-0 z-50 flex justify-center items-center bg-white">
        <div className="animate-spin rounded-full h-25 w-25 md:h-32 md:w-32 border-t-2 border-b-2 border-indigo-500"></div>
    </div>
);

export default LoadingSpinner;